/**
 * Server-side feedback email delivery via the upload orchestrator.
 * Replaces the browser-side EmailJS calls so no EmailJS keys ship in the bundle.
 */
import { getOrchestratorBaseUrl } from "../../magic-link/guestSession";
/** Best-effort: resolves to { sent } and never rejects on delivery failure
 *  (mirrors the old EmailJS behavior where errors were only logged). */
export async function sendFeedbackEmail(payload) {
    try {
        const res = await fetch(`${getOrchestratorBaseUrl()}/feedback/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            console.log("Feedback email not sent:", data?.error || res.status);
            return { sent: false };
        }
        return { sent: data?.sent === true };
    }
    catch (e) {
        console.log("Feedback email not sent:", e);
        return { sent: false };
    }
}
